import styled from 'styled-components';
import { Icon } from '@iconify/react';

interface Props {
  size: string;
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ImageContainer = styled.div<Props>`
  width: ${props => props.size};
  height: ${props => props.size};
  border-radius: 50%;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  flex: 1;
  height: auto;
  width: auto;
  object-fit: cover;
  border-radius: 50%;
`;

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: 5px;
  width: 7rem;
  margin-left: 10px;
`;

export const ProfileName = styled.span`
  color: ${props => props.theme.colors.text};
  transition: 200ms;

  font-size: 12px;
  font-weight: 700;
  
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-align: start;
`;

export const UserRole = styled.span`
  color: ${props => props.theme.colors.text};
  transition: 200ms;

  font-weight: 400;
  font-size: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-align: start;
`;

export const DropdownIcon = styled(Icon)`
  align-self: flex-start;
`;
